import React from "react";
import { object } from "prop-types";
import get from "lodash/get";

import AuthorDetails from "../../../molecules/AuthorDetails";
import NewsHeadline from "../../../atoms/NewsHeadline";
import Excerpt from "../../../atoms/Excerpt";

import { getExcerpt } from "../../../utils/utils";

import "./organism1.m.css";

const Organism1 = ({ story: { story } }) => {
  const storyObj = story;
  const excerpt = getExcerpt(story);
  const hideAuthorName = get(storyObj, ["metadata", "story-attributes", "hideauthor", 0], "no");

  return (
    <div styleName="base" className="organism1">
      <div>
        <NewsHeadline story={story} cssStyleName="bigSize" />
        <Excerpt excerpt={excerpt} url={story.url} />
      </div>
      {hideAuthorName === "no" && (
        <AuthorDetails
          story={storyObj}
          contributorType={storyObj.authors.length > 1 ? 2 : 1}
          withAvatar={true}
          authorDetailsType="opinion-stories-author-details"
          location={true}
        />
      )}
    </div>
  );
};

Organism1.propTypes = {
  story: object.isRequired,
};

export default Organism1;
